import * as React from 'react';
import api from './ApiClient';
import moment from 'moment';
import Security from './Security';
import { Button, ButtonGroup, Form, InputGroup } from 'react-bootstrap';
import EditCompetitor from './EditCompetitor';

interface RaceCompetitorsListProps {
	raceId: string;
}

interface RaceCompetitorsListState {
	competitors: any[];
	editCompetitorId: string;
	race: any;
	filter: string;
	sortColumn: string;
	sortDescending: boolean;
}

export default class RaceCompetitorsList extends React.Component<RaceCompetitorsListProps, RaceCompetitorsListState> {
	constructor(props: RaceCompetitorsListProps) {
		super(props);

		this.state = {
			competitors: [],
			editCompetitorId: '',
			race: {},
			filter: '',
			sortColumn: 'number',
			sortDescending: false
		};

		this.competitorSaved = this.competitorSaved.bind(this);
	}

	async componentDidMount() {
		await this.loadCompetitors();
		this.getRace();
	}

	async loadCompetitors() {
		var competitorsPromise = api.request('competitors/inrace?raceid=' + this.props.raceId).then(data => {
			this.setState({
				competitors: data
			});
		});

		await competitorsPromise;
	}

	getRace() {
		api.request('races/' + this.props.raceId).then(data => {
			this.setState({
				race: data
			});
		});
	}

	async deleteCompetitor(competitor: any) {
		if (confirm('Are you sure you want to delete competiror #' + competitor.number + " - " + competitor.name + '?')) {
			await api.delete('Competitors/Competitor/' + competitor.id);
			this.loadCompetitors();
		}
	}

	competitorSaved(competitor: any) {
		var competitors = this.state.competitors.map(existing =>
			existing.id === this.state.editCompetitorId ? { ...existing, ...competitor } : existing
		);
		this.setState({ competitors: competitors, editCompetitorId: '' });
	}

	sortBy(column: string) {
		this.setState(state => ({
			sortColumn: column,
			sortDescending: state.sortColumn === column ? !state.sortDescending : false
		}));
	}

	sortIndicator(column: string) {
		if (this.state.sortColumn !== column) return '';
		return this.state.sortDescending ? ' ▼' : ' ▲';
	}

	compareValues(a: any, b: any) {
		var aEmpty = a === null || a === undefined || a === '';
		var bEmpty = b === null || b === undefined || b === '';
		if (aEmpty || bEmpty) return aEmpty && bEmpty ? 0 : aEmpty ? 1 : -1;

		var aNumber = Number(a);
		var bNumber = Number(b);
		if (!isNaN(aNumber) && !isNaN(bNumber)) return aNumber - bNumber;

		return a.toString().localeCompare(b.toString());
	}

	matchesFilter(competitor: any) {
		if (!this.state.filter.trim()) return true;
		const f = this.state.filter.toLowerCase();
		if (competitor.name?.toLowerCase().includes(f)) return true;
		if (competitor.number?.toString().includes(f)) return true;
		if (competitor.group?.toLowerCase().includes(f)) return true;
		return false;
	}

	getVisibleCompetitors() {
		var visible = this.state.competitors.filter(competitor => this.matchesFilter(competitor));

		visible.sort((a, b) => {
			var result = this.compareValues(a[this.state.sortColumn], b[this.state.sortColumn]);
			return this.state.sortDescending ? -result : result;
		});

		return visible;
	}

	render() {
		if (this.state.editCompetitorId) {
			return (
				<div>
					<EditCompetitor
						race={this.state.race}
						competitorId={this.state.editCompetitorId}
						onCancel={() => this.setState({ editCompetitorId: '' })}
						onSave={this.competitorSaved}
					/>
				</div>
			);
		} else {
			var visibleCompetitors = this.getVisibleCompetitors();

			var sortableHeader = (column: string, title: string) => (
				<th style={{ cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={() => this.sortBy(column)}>
					{title}{this.sortIndicator(column)}
				</th>
			);

			return (
				<div>
					<InputGroup className="mb-3" style={{ maxWidth: 400 }}>
						<InputGroup.Text>Filter</InputGroup.Text>
						<Form.Control
							type="text"
							placeholder="Name, number, or group..."
							value={this.state.filter}
							onChange={(e) => this.setState({ filter: e.target.value })}
						/>
						{this.state.filter && (
							<Button variant="outline-secondary" onClick={() => this.setState({ filter: '' })}>&times;</Button>
						)}
					</InputGroup>

					<table className="table">
						<thead>
							<tr>
								{sortableHeader('number', 'Number')}
								{sortableHeader('name', 'Name')}
								{sortableHeader('ssn', 'SSN')}
								{sortableHeader('age', 'Age')}
								{sortableHeader('transponder', 'Transponder')}
								{sortableHeader('group', 'Group')}
								<th></th>
								{Security.isAdmin() && <th className="d-flex justify-content-end">Actions</th>}
							</tr>
						</thead>
						<tbody>
							{visibleCompetitors.map((competitor) => {
								return (
									<tr key={competitor.id}>
										<td>{competitor.number}</td>
										<td>{competitor.name}</td>
										<td>{competitor.ssn}</td>
										<td>{competitor.age}</td>
										<td>{competitor.transponder}</td>
										<td>{competitor.group}</td>
										<td></td>
										{Security.isAdmin() &&
											<td className="d-flex justify-content-end">
												<ButtonGroup>
													<Button variant="warning" onClick={() => this.deleteCompetitor(competitor)}>Delete</Button>
													<Button variant="primary" onClick={() => this.setState({ editCompetitorId: competitor.id })}>Edit</Button>
												</ButtonGroup>
											</td>
										}
									</tr>
								)
							})}
						</tbody>
					</table>
				</div>
			)
		}
	}
}